import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SupportTicketList from '../../components/support/tickets/SupportTicketList';
import PageHeader from '../../components/shared/PageHeader';
import CreateTicketButton from '../../components/shared/CreateTicketButton';
import { useCreateTicketModal } from '../../context/CreateTicketModalContext';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  background-color: var(--color-bg-secondary);
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ListSection = styled.section`
  background: var(--color-bg-primary);
  border-radius: 12px;
  width: 100%;
  overflow: visible;
  border: 1px solid var(--color-border-primary);
  box-shadow: var(--shadow-sm);
  padding: 1.5rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const TicketListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { openCreateTicket } = useCreateTicketModal();
  const openCreateRequested = Boolean(location.state?.openCreateTicket);

  useEffect(() => {
    if (!openCreateRequested) return;
    openCreateTicket();
    // Limpa o state para que recarregar a página não reabra o modal.
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [openCreateRequested, openCreateTicket, location.pathname, location.search, navigate]);

  return (
    <PageContainer>
      <ContentContainer>
        <PageHeader
          title="Meus tickets"
          description="Acompanhe o andamento dos tickets que você abriu."
          actions={<CreateTicketButton />}
        />
        <ListSection>
          <SupportTicketList mode="user" />
        </ListSection>
      </ContentContainer>
    </PageContainer>
  );
};

export default TicketListPage;
